const types = {
    GET_REPORT: 'GET_REPORT',
    STORE_REPORT: 'STORE_REPORT',
    FILTER_REPORT: 'FILTER_REPORT',
    CHANGE_DATA_REPORT: 'CHANGE_DATA_REPORT',
    DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
    CLEAR_REPORT: 'CLEAR_REPORT'
}

export default types;

export const getReport = (id, pageSelected, filters, page, rowsPerPage) => {
    return { type: types.GET_REPORT, payload: { id, pageSelected, filters, page, rowsPerPage } };
}

export const storeReport = (response) => {
    return { type: types.STORE_REPORT, payload: response };
}

export const filterReport = (id, pageSelected, filters, page, rowsPerPage) => {
    return { type: types.FILTER_REPORT, payload: { id, pageSelected, filters, page, rowsPerPage } };
}

export const changeDataReport = (response) => {
    return { type: types.CHANGE_DATA_REPORT, payload: response };
}

export const clearReport = () => {
    return { type: types.CLEAR_REPORT };
}